import type { RowInformation } from '../../config/flavourConfig';
import { Link, Table } from '@flos/react-ui';
import { formatCoverableFieldValue } from '../../utils/coverablesUtil';
import { useState } from 'react';
import { createPortal } from 'react-dom';

const TableRow = ({
    rowInfo,
    hideFieldValue = false,
    shouldAlignTextLeftOnMobile
}: {
    rowInfo: RowInformation;
    hideFieldValue?: boolean;
    shouldAlignTextLeftOnMobile?: boolean;
}): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const formattedFieldValue = formatCoverableFieldValue(rowInfo.fieldValue ?? '');

    return (
        <>
            <Table.Row>
                <Table.Cell>
                    {rowInfo.labelType === 'modalLink' && (
                        <Link
                            className="u-color-primary-2-base u-Normalwrap"
                            onClick={() => {
                                setShowModal(true);
                            }}
                        >
                            <span>{rowInfo.name}</span>
                        </Link>
                    )}
                    {rowInfo.labelType === 'bold' && (
                        <h6 className="u-spacing-stack-bottom-none u-Normalwrap">{rowInfo.name}</h6>
                    )}
                    {(rowInfo.labelType === 'normal' || rowInfo.labelType === undefined) && (
                        <span className="u-Normalwrap">{rowInfo.name}</span>
                    )}
                </Table.Cell>
                {!hideFieldValue && (
                    <Table.Cell
                        className={shouldAlignTextLeftOnMobile ? 'u-text-right@xs' : 'u-text-right'}
                    >
                        {rowInfo.valueType === 'modalLink' ? (
                            <Link
                                className="u-color-primary-2-base u-Normalwrap"
                                onClick={() => {
                                    setShowModal(true);
                                }}
                            >
                                {formattedFieldValue}
                            </Link>
                        ) : (
                            <span
                                className={
                                    rowInfo.valueType === 'amount' ? 'u-Nowrap' : 'u-Normalwrap'
                                }
                            >
                                {formattedFieldValue}
                            </span>
                        )}
                    </Table.Cell>
                )}
            </Table.Row>
            {showModal &&
                rowInfo.modalInformation &&
                createPortal(
                    <rowInfo.modalInformation.modalType
                        showModal={showModal}
                        modalProps={rowInfo.modalInformation.modalProps}
                        closeModal={() => {
                            setShowModal(false);
                        }}
                    />,
                    document.body
                )}
        </>
    );
};

export default TableRow;
